module.exports = __webpack_public_path__ + "static/media/religare1920.261e2748.jpg";